import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { DashboardShell } from '@/components/layout/DashboardShell';
import { adminService } from '@/services/admin';
import { AttendanceStatsCards } from '@/components/admin/attendance/AttendanceStatsCards';
import { AttendanceActionList } from '@/components/admin/attendance/AttendanceActionList';

export default function AdminAttendanceClassPage() {
    // 1. Fetch Classes for Dropdown
    const { data: classes } = useQuery({
        queryKey: ['classes'],
        queryFn: adminService.listClasses
    });

    const [selectedClassId, setSelectedClassId] = useState<string>('');

    // 2. Fetch Class Attendance only if selected
    const { data, isLoading } = useQuery({
        queryKey: ['class-attendance-summary', selectedClassId],
        queryFn: () => adminService.getAttendanceSummary(selectedClassId, { period: 'daily' }),
        enabled: !!selectedClassId,
    });

    const handleSendMessage = (recordId: string) => {
        alert(`Sending message to record ID: ${recordId}`);
    };

    const handleSendBulk = (recordIds: string[]) => {
        alert(`Sending bulk messages to: ${recordIds.length} students`);
    };

    return (
        <DashboardShell title="Class Attendance" role="admin">
            <div className="space-y-8">
                {/* 1. Class Selector */}
                <div className="w-full md:w-1/3">
                    <label className="block text-sm font-medium text-slate-700 mb-1">Select Class</label>
                    <select
                        className="w-full rounded-md border-slate-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                        value={selectedClassId}
                        onChange={(e) => setSelectedClassId(e.target.value)}
                    >
                        <option value="">-- Choose a Class --</option>
                        {classes?.map((cls: any) => (
                            <option key={cls.id} value={cls.id}>{cls.name}</option>
                        ))}
                    </select>
                </div>

                {selectedClassId ? (
                    <>
                        <AttendanceStatsCards
                            summary={data?.summary || { total: 0, present: 0, absent: 0, late: 0, leave: 0, messageSent: 0 }}
                            loading={isLoading}
                        />
                        <AttendanceActionList
                            records={data?.records || []}
                            onSendMessage={handleSendMessage}
                            onSendBulk={handleSendBulk}
                        />
                    </>
                ) : (
                    <div className="p-12 text-center text-slate-500 bg-slate-50 rounded-lg border border-dashed border-slate-300">
                        Please select a class to view attendance details.
                    </div>
                )}
            </div>
        </DashboardShell>
    );
}
